export const YM_COUNTER_ID = 69038977

export const APP_HEADER_HEIGHT = 73

export const DOCTOR_IMG_PLACEHOLDER = '/graphics/doctor-placeholder.svg'
export const LPU_IMG_PLACEHOLDER = '/graphics/lpu-placeholder.svg'
export const STAGE_ORIGIN_URL = 'https://award.prodoctorov.com'
